import { render, staticRenderFns } from "./OrderDialogHeader.vue?vue&type=template&id=3ac6ef70&scoped=true"
import script from "./OrderDialogHeader.vue?vue&type=script&lang=js"
export * from "./OrderDialogHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac6ef70",
  null
  
)

export default component.exports